import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesignAngularKitModule } from 'design-angular-kit';
import { RequestDto } from '../../../../models/request.dto';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-request-carousel',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, RouterModule],
  templateUrl: './request-carousel.component.html',
  styleUrl: './request-carousel.component.scss',
})
export class RequestCarouselComponent {
  @Input() requestToComplete: RequestDto[] = [];

    constructor() {
    }
    ngOnInit() {
    }
}
